import axios from 'axios'
import { API_BASE, apiErrorHandler } from '../api'
import Auth from '../auth'

const ADD_PAYMENT_METHOD = `${API_BASE}stripe/add-payment-method/`
const LIST_PAYMENT_METHODS = `${API_BASE}stripe/list-payment-methods/`
const UPDATE_DEFAULT_PAYMENT_METHOD = `${API_BASE}stripe/update-default-payment-method/`

export default class PaymentMethodAPI {
  constructor(cls) {
    this.cls = cls
  }
  static create(cls) {
    return new PaymentMethodAPI(cls)
  }

  async list() {
    const options = {
      headers: {
        ...Auth.getHeaders(),
        'Content-Type': 'application/json',
      },
    }
    const promise = axios.get(LIST_PAYMENT_METHODS, options)
    return promise
      .then(response => response.data.payment_methods.map(this.cls.fromAPI))
      .catch(apiErrorHandler({ apiName: 'List Payment Methods' }))
  }

  async addPaymentMethod(token) {
    const options = {
      headers: {
        ...Auth.getHeaders(),
        'Content-Type': 'application/json',
      },
    }
    const data = {
      token: token,
    }
    const promise = axios.post(ADD_PAYMENT_METHOD, data, options)
    return promise
      .then(res => this.cls.fromAPI(res.data.payment_method))
      .catch(apiErrorHandler({ apiName: 'Add Payment API error' }))
  }

  updateDefaultPaymentMethod(card) {
    const options = {
      headers: {
        ...Auth.getHeaders(),
        'Content-Type': 'application/json',
      },
    }
    const data = {
      card_id: card.id,
    }
    const promise = axios.post(UPDATE_DEFAULT_PAYMENT_METHOD, data, options)
    return promise.then(res => res.data)
  }
}
